module.exports = __webpack_public_path__ + "static/img/m_role.c7e0ddb.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/zxrx/m_role.png
// module id = eKnd
// module chunks = 7